import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  Textarea,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  VStack,
  FormControl,
  FormLabel,
  useColorModeValue,
  chakra,
  Center,
  Text,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { fetchCardWorklogs, addCardWorklog } from "../../../../ProjectBoardServices/BoardModalAPI/LeftModalAPI/WorkLogTabAPI";

const WorkLog = ({ task }) => {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    date: "",
    title: "",
    duration: "",
    comment: "",
  });
  const [entries, setEntries] = useState([]);

  const tableBg = useColorModeValue("white", "gray.800");
  const headerBg = useColorModeValue("blue.500", "blue.600");
  const headerColor = useColorModeValue("white", "gray.100");
  const rowHoverBg = useColorModeValue("blue.50", "gray.700");

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      // ✅ Service function use kar rahe hain
      const res = await fetchCardWorklogs(task?.id);
      setEntries(res.data?.data || []);
    } catch (err) {
      console.error("Error fetching worklogs:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.date || !form.title) {
      alert("Please fill in Date and Name");
      return;
    }
    const formData = new FormData();
    formData.append("date", form.date.split("-").reverse().join("/"));
    formData.append("title", form.title);
    formData.append("duration", form.duration || "0");
    formData.append("comment", form.comment);

    try {
      // ✅ Service function use kar rahe hain
      await addCardWorklog(task?.id, formData);
      await fetchLogs();
      setForm({ date: "", title: "", duration: "", comment: "" });
      setShowForm(false);
    } catch (err) {
      alert("Failed to add worklog");
      console.error("Add worklog error:", err);
    }
  };

  const handleCancel = () => {
    setForm({ date: "", title: "", duration: "", comment: "" });
    setShowForm(false);
  };

  return (
    <Box p={4} bg={tableBg} borderRadius="md" shadow="md" maxW="800px" mx="auto">
      {/* Header with button */}
      <Flex justify="flex-end" mb={3}>
        <Button
          size="sm"
          leftIcon={<AddIcon />}
          colorScheme="blue"
          borderRadius="full"
          onClick={() => setShowForm(true)}
          disabled={showForm}
        >
          Add Work Log
        </Button>
      </Flex>

      {/* Modern Add Form */}
      {showForm && (
        <Box
          mb={5}
          p={4}
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          bg="gray.50"
        >
          <VStack spacing={3} align="stretch">
            <HStack spacing={3}>
              <FormControl>
                <FormLabel fontSize="xs" fontWeight="600" color="gray.700">
                  Date *
                </FormLabel>
                <Input
                  name="date"
                  size="sm"
                  value={form.date}
                  onChange={handleChange}
                  type="date"
                  bg="white"
                  fontSize="sm"
                />
              </FormControl>
              <FormControl>
                <FormLabel fontSize="xs" fontWeight="600" color="gray.700">
                  Name *
                </FormLabel>
                <Input
                  name="title"
                  placeholder="Enter your name"
                  size="sm"
                  value={form.title}
                  onChange={handleChange}
                  bg="white"
                  fontSize="sm"
                />
              </FormControl>
              {/* <FormControl>
                <FormLabel fontSize="xs" fontWeight="600" color="gray.700">
                  Duration (min) *
                </FormLabel>
                <Input
                  name="duration"
                  placeholder="e.g. 60"
                  size="sm"
                  value={form.duration}
                  onChange={handleChange}
                  bg="white"
                  fontSize="sm"
                />
              </FormControl> */}
            </HStack>
            <FormControl>
              <FormLabel fontSize="xs" fontWeight="600" color="gray.700">
                Comment
              </FormLabel>
              <Textarea
                name="comment"
                placeholder="Add notes..."
                size="sm"
                value={form.comment}
                onChange={handleChange}
                resize="vertical"
                rows={2}
                bg="white"
                fontSize="sm"
              />
            </FormControl>
            <Flex justify="flex-end" gap={2} pt={2}>
              <Button size="sm" variant="outline" onClick={handleCancel}>
                Cancel
              </Button>
              <Button size="sm" colorScheme="blue" onClick={handleSubmit}>
                Submit
              </Button>
            </Flex>
          </VStack>
        </Box>
      )}

      {/* Table */}
      <Box border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Table size="sm" fontSize="xs">
          <Thead bg={headerBg} position="sticky" top={0} zIndex={1}>
            <Tr>
              <Th color={headerColor} fontSize="xs" py={2}>
                Date
              </Th>
              <Th color={headerColor} fontSize="xs" py={2}>
                Name
              </Th>
              {/* <Th color={headerColor} fontSize="xs" py={2}>
                Duration
              </Th> */}
              <Th color={headerColor} fontSize="xs" py={2}>
                Comment
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {entries.length === 0 ? (
              <Tr>
                <Td colSpan={4}>
                  <Center py={8}>
                    <Text fontSize="xs" color="gray.500">
                      No work log entries yet.
                    </Text>
                  </Center>
                </Td>
              </Tr>
            ) : (
              entries.map((entry, idx) => (
                <Tr
                  key={entry.id || idx}
                  _hover={{ bg: rowHoverBg, transition: "all 0.2s" }}
                >
                  <Td fontSize="xs" py={1}>
                    {entry.date}
                  </Td>
                  <Td fontSize="xs" py={1}>
                    {entry.title}
                  </Td>
                  {/* <Td fontSize="xs" py={1}>
                    {entry.duration || entry.duartion || "-"}
                  </Td> */}
                  <Td fontSize="xs" py={1} whiteSpace="pre-wrap" maxW="200px">
                    <chakra.span color="gray.600">
                      {entry.comment?.trim() || "-"}
                    </chakra.span>
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default WorkLog;